import React, { useState } from 'react';
import { Form, Input, Button, Alert } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Navigate } from 'react-router';
import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { useWindowSize } from 'react-use';
import classNames from 'classnames';
import queryString from 'query-string';

import { MIN_MD } from 'constants/ThemeSetting';
import Loading from 'components/Loading';
import axios from 'util/Api';
import useInvitation from 'hooks/data/useInvitation';
import BranchIntro from 'components/Auth/BranchIntro';

export default function Invitation() {
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const { key } = queryString.parse(location.search);
  const { invitation, loading, error } = useInvitation(key);
  const { width } = useWindowSize();
  const formBtnSumitClasses = classNames({
    'omi-auth-form-submit': true,
    'mt-10 md:mt-16': !error,
  });
  const alertClasses = classNames({
    'omi-auth-alert': true,
    'flex items-center mt-8 md:mt-12': errorMessage,
    hidden: !errorMessage,
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Navigate to="/500" />;
  }

  if (invitation.accepted) {
    navigate('/login');
  }

  const acceptInvitation = async values => {
    setSubmitting(true);
    try {
      values.key = key;
      values.accepted = true;
      await axios.post(`/api/v1/invitations`, {
        ...values,
      });
      navigate('/login');
    } catch (e) {
      setErrorMessage('Không thể đăng kí người dùng!');
    }
    setSubmitting(false);
  };

  const handleSubmit = values => {
    acceptInvitation(values);
  };

  return (
    <div className="flex flex-col lg:flex-row lg:h-auto">
      <div className="omi-auth-layout-title">
        <BranchIntro />
      </div>
      <div className="omi-auth-layout-content">
        <div className="flex lg:h-auto flex-col justify-start items-center m-6 mt-0 sm:mx-40 lg:justify-center lg:p-0 lg:mb-0">
          <div className="omi-auth-form invitation-container">
            <p className="omi-auth-form-title">Xin chào,</p>
            <p className="mb-6 lg:mb-8 text-base f-semibold">{invitation.email}</p>
            <Form
              name="invitaion"
              layout="vertical"
              size={width >= MIN_MD ? 'large' : 'middle'}
              onFinish={handleSubmit}
            >
              <div className="inline-block w-1/2 pr-2">
                <Form.Item
                  label="Họ"
                  name="last_name"
                  rules={[
                    {
                      required: true,
                      message: 'Yêu cầu nhập họ.',
                    },
                  ]}
                >
                  <Input placeholder="Vd: Nguyễn Văn" />
                </Form.Item>
              </div>
              <div className="inline-block w-1/2 pl-2">
                <Form.Item
                  label="Tên"
                  name="first_name"
                  rules={[
                    {
                      required: true,
                      message: 'Yêu cầu nhập tên.',
                    },
                  ]}
                >
                  <Input placeholder="Vd: A" />
                </Form.Item>
              </div>
              <Form.Item
                label="Số điện thoại"
                name="tel"
                rules={[
                  {
                    required: true,
                    message: 'Yêu cầu nhập số điện thoại.',
                  },
                ]}
              >
                <Input placeholder="Nhập số điện thoại" />
              </Form.Item>

              <Form.Item
                label="Passwrod"
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Yêu cầu nhập mật khẩu.',
                  },
                ]}
              >
                <Input.Password
                  iconRender={visible =>
                    visible ? <EyeFilled width={18} height={18} /> : <EyeInvisibleFilled width={18} height={18} />
                  }
                  placeholder="Mật khẩu"
                />
              </Form.Item>
              <Form.Item className={formBtnSumitClasses}>
                <Alert className={alertClasses} message={errorMessage} type="error" showIcon />
                <Button type="primary" htmlType="submit" block loading={submitting}>
                  Đăng ký
                </Button>
              </Form.Item>
              <div className="flex justify-end mt-4">
                <Link to="/login" className="f-semibold text-grey-700 text-xs sm:text-sm sm:mb-8">
                  Trở về đăng nhập
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
